import React, { useMemo, useState } from 'react';
import { Box, Grid, Typography, Button, Stack } from '@mui/material';

import img0006 from './Gallery/IMG-20250514-WA0006.webp';
import img0007 from './Gallery/IMG-20250514-WA0007.webp';
import img0008 from './Gallery/IMG-20250514-WA0008.webp';
import img0009 from './Gallery/IMG-20250514-WA0009.webp';
import img0010 from './Gallery/IMG-20250514-WA0010.webp';
import img0011 from './Gallery/IMG-20250514-WA0011.webp';
import img0012 from './Gallery/IMG-20250514-WA0012.webp';
import img0013 from './Gallery/IMG-20250514-WA0013.webp';
import img0014 from './Gallery/IMG-20250514-WA0014.webp';
import img0015 from './Gallery/IMG-20250514-WA0015.webp';
import img0016 from './Gallery/IMG-20250514-WA0016.webp';
import img0017 from './Gallery/IMG-20250514-WA0017.webp';
import img0018 from './Gallery/IMG-20250514-WA0018.webp';
import img0019 from './Gallery/IMG-20250514-WA0019.webp';
import img0020 from './Gallery/IMG-20250514-WA0020.webp';
import img0021 from './Gallery/IMG-20250514-WA0021.webp';
import img0022 from './Gallery/IMG-20250514-WA0022.webp';
import img0023 from './Gallery/IMG-20250514-WA0023.webp';
import img0024 from './Gallery/IMG-20250514-WA0024.webp';
import img0025 from './Gallery/IMG-20250514-WA0025.webp';
import img0026 from './Gallery/IMG-20250514-WA0026.webp';
import img0027 from './Gallery/IMG-20250514-WA0027.webp';
import img0028 from './Gallery/IMG-20250514-WA0028.webp';
import img0029 from './Gallery/IMG-20250514-WA0029.webp';
import img0030 from './Gallery/IMG-20250514-WA0030.webp';
import img0031 from './Gallery/IMG-20250514-WA0031.webp';
import img0032 from './Gallery/IMG-20250514-WA0032.webp';
import img0033 from './Gallery/IMG-20250514-WA0033.webp';
import img0034 from './Gallery/01.webp';
import img0035 from './Gallery/02.webp';
import img0036 from './Gallery/03.webp';
import img0037 from './Gallery/04.webp';
import img0038 from './Gallery/05.webp';
import img0039 from './Gallery/06.webp';
import img0040 from './Gallery/07.webp';
import img0041 from './Gallery/08.webp';
import img0042 from './Gallery/09.webp';
import img0043 from './Gallery/10.webp';
import img0044 from './Gallery/11.webp';
import img0045 from './Gallery/12.webp';
import img0046 from './Gallery/13.webp';
import img0047 from './Gallery/14.webp';
import jun01 from './Gallery/jun1.webp';
import jun02 from './Gallery/jun2.webp';
import jun03 from './Gallery/jun3.webp';
import jun04 from './Gallery/jun4.webp';
import jun05 from './Gallery/jun5.webp';
import jun06 from './Gallery/jun6.webp';
import jun07 from './Gallery/jun7.webp';
import jun08 from './Gallery/jun8.webp';
import jun09 from './Gallery/jun9.webp';
import jun10 from './Gallery/jun10.webp';
import jun11 from './Gallery/jun11.webp';
import jun12 from './Gallery/jun12.webp';
import jun13 from './Gallery/jun13.webp';
import jun14 from './Gallery/jun14.webp';
import jun15 from './Gallery/jun15.webp';
import jun16 from './Gallery/jun16.webp';
import jun17 from './Gallery/jun17.webp';
import jun18 from './Gallery/jun18.webp';
import jun19 from './Gallery/jun19.webp';
import jun20 from './Gallery/jun20.webp';
import jun21 from './Gallery/jun21.webp';
import jun22 from './Gallery/jun22.webp';
import jun23 from './Gallery/jun23.webp';

import serahterima1 from './images/serahterima/1.webp';
import serahterima2 from './images/serahterima/2.webp';
import serahterima3 from './images/serahterima/3.webp';
import serahterima4 from './images/serahterima/4.webp';
import serahterima5 from './images/serahterima/5.webp';
import serahterima6 from './images/serahterima/6.webp';
import serahterima7 from './images/serahterima/7.webp';
import serahterima8 from './images/serahterima/8.webp';
import serahterima9 from './images/serahterima/9.webp';
import serahterima10 from './images/serahterima/10.webp';
import serahterima11 from './images/serahterima/11.webp';
import serahterima12 from './images/serahterima/12.webp';
import serahterima13 from './images/serahterima/13.webp';
import serahterima14 from './images/serahterima/14.webp';
import serahterima15 from './images/serahterima/15.webp';
import serahterima16 from './images/serahterima/16.webp';
import serahterima17 from './images/serahterima/17.webp';
import serahterima18 from './images/serahterima/18.webp';
import serahterima19 from './images/serahterima/19.webp';
import serahterima20 from './images/serahterima/20.webp';
import serahterima21 from './images/serahterima/21.webp';
import serahterima22 from './images/serahterima/22.webp';
import serahterima23 from './images/serahterima/23.webp';
import serahterima24 from './images/serahterima/24.webp';
import serahterima25 from './images/serahterima/25.webp';

const serahTerimaImages = [
  serahterima1,
  serahterima2,
  serahterima3,
  serahterima4,
  serahterima5,
  serahterima6,
  serahterima7,
  serahterima8,
  serahterima9,
  serahterima10,
  serahterima11,
  serahterima12,
  serahterima13,
  serahterima14,
  serahterima15,
  serahterima16,
  serahterima17,
  serahterima18,
  serahterima19,
  serahterima20,
  serahterima21,
  serahterima22,
  serahterima23,
  serahterima24,
  serahterima25,
];

const otherImages = [
  jun01,
  jun02,
  jun03,
  jun04,
  jun05,
  jun06,
  jun07,
  jun08,
  jun09,
  jun10,
  jun11,
  jun12,
  jun13,
  jun14,
  jun15,
  jun16,
  jun17,
  jun18,
  jun19,
  jun20,
  jun21,
  jun22,
  jun23,
  img0034,
  img0035,
  img0036,
  img0037,
  img0038,
  img0039,
  img0040,
  img0041,
  img0042,
  img0043,
  img0044,
  img0045,
  img0046,
  img0047,
  img0006,
  img0007,
  img0008,
  img0009,
  img0010,
  img0011,
  img0012,
  img0013,
  img0014,
  img0015,
  img0016,
  img0017,
  img0018,
  img0019,
  img0020,
  img0021,
  img0022,
  img0023,
  img0024,
  img0025,
  img0026,
  img0027,
  img0028,
  img0029,
  img0030,
  img0031,
  img0032,
  img0033,
];

function Gallery() {
  const initialCount = 9;
  const loadCount = 9;
  const [visibleCount, setVisibleCount] = useState(initialCount);

  const galleryImages = useMemo(() => {
    return [...serahTerimaImages, ...otherImages];
  }, []);

  const visibleImages = galleryImages.slice(0, visibleCount);
  const hasMore = visibleCount < galleryImages.length;

  const handleShowMore = () => {
    setVisibleCount((prev) => Math.min(prev + loadCount, galleryImages.length));
  };

  return (
    <Box
      sx={{
        px: { xs: 2, sm: 6, md: 10 },
        pt: { xs: 12, sm: 14, md: 16 },
        pb: { xs: 4, sm: 8 },
        scrollMarginTop: { xs: '80px', sm: '90px', md: '100px' },
      }}
    >
      <Typography
        variant='h1'
        component='h1'
        fontWeight='bold'
        sx={{
          textAlign: 'center',
          mb: 4,
          fontSize: { xs: '2rem', sm: '2.5rem' },
        }}
      >
        Serah Terima Unit
      </Typography>

      <Grid container spacing={2}>
        {visibleImages.map((image, index) => (
          <Grid item xs={6} sm={4} md={3} key={index}>
            <Box
              sx={{
                width: '100%',
                paddingTop: '100%',
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 2,
                boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
                bgcolor: '#fff',
                '&:hover img': { transform: 'scale(1.05)' },
              }}
            >
              <Box
                component='img'
                src={image}
                alt={`Gallery ${index + 1}`}
                loading='lazy'
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      {hasMore && (
        <Stack alignItems='center' sx={{ mt: 4 }}>
          <Button
            variant='contained'
            onClick={handleShowMore}
            sx={{
              px: 4,
              py: 1.2,
              borderRadius: 999,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Show More
          </Button>
        </Stack>
      )}
    </Box>
  );
}

export default Gallery;
